 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result":"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result","cover":"cover","intro~list~profiling~q-imageInation~result":"intro~list~profiling~q-imageInation~result","ic_url~list~page404~profiling~redirect":"ic_url~list~page404~profiling~redirect","list":"list","profiling~q-tebakSkor~questions":"profiling~q-tebakSkor~questions","profiling":"profiling","intro~q-polling~q-survey~r-polling~r-survey":"intro~q-polling~q-survey~r-polling~r-survey","intro~result":"intro~result","intro":"intro","result":"result","form":"form","ic_url":"ic_url","page404":"page404","redirect":"redirect","leaderboard":"leaderboard","leaderboard_page":"leaderboard_page","leaderboard_widget":"leaderboard_widget","login":"login","question":"question","unique":"unique","r-polling":"r-polling","r-survey":"r-survey","r-checklist":"r-checklist","r-imageInation":"r-imageInation","r-majority":"r-majority","r-personality":"r-personality","r-spinWin":"r-spinWin","r-tebakSkor":"r-tebakSkor","r-timer":"r-timer","r-trivia":"r-trivia","q-imageInation":"q-imageInation","q-tebakSkor":"q-tebakSkor","q-spinWin":"q-spinWin","q-polling":"q-polling","q-survey":"q-survey","q-checklist":"q-checklist","q-majority":"q-majority","q-personality":"q-personality","q-pickapict":"q-pickapict","q-trivia":"q-trivia","share":"share","quiz-imageination":"quiz-imageination","quiz":"quiz","questions":"questions","timer":"timer","shuffle":"shuffle"}[chunkId]||chunkId) + "." + {"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result":"befbd155","cover":"ec9708d6","intro~list~profiling~q-imageInation~result":"de2bc8fe","ic_url~list~page404~profiling~redirect":"72fe3b2b","list":"96b7af28","profiling~q-tebakSkor~questions":"fcc9c354","profiling":"c390e122","intro~q-polling~q-survey~r-polling~r-survey":"c1575873","intro~result":"60eee46b","intro":"b759ad29","result":"7304b992","form":"c47b68b5","ic_url":"f187dbd1","page404":"ce5e8d99","redirect":"1bb3e3a6","leaderboard":"371a553e","leaderboard_page":"6bf904f0","leaderboard_widget":"150641fe","login":"a45a0292","question":"f92ef84c","unique":"0c340f13","r-polling":"ccc5b781","r-survey":"f0507c04","r-checklist":"52f74958","r-imageInation":"4afa9ec9","r-majority":"395e99ab","r-personality":"fee67838","r-spinWin":"917c2a2e","r-tebakSkor":"21180552","r-timer":"d54e9dce","r-trivia":"6cb99505","q-imageInation":"8e581f48","q-tebakSkor":"15d464cb","q-spinWin":"14adafe7","q-polling":"863a8000","q-survey":"663322cc","q-checklist":"d6be0306","q-majority":"44ed116b","q-personality":"1db510e6","q-pickapict":"da55e1d0","q-trivia":"26e297f8","share":"cf59dcc6","quiz-imageination":"b8a6cbe4","quiz":"037ba737","questions":"0e9e33f6","timer":"f19c5b16","shuffle":"703716f7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result":1,"cover":1,"intro~list~profiling~q-imageInation~result":1,"ic_url~list~page404~profiling~redirect":1,"list":1,"profiling~q-tebakSkor~questions":1,"profiling":1,"intro~result":1,"intro":1,"ic_url":1,"page404":1,"redirect":1,"leaderboard_page":1,"leaderboard_widget":1,"login":1,"unique":1,"r-polling":1,"r-survey":1,"r-imageInation":1,"r-personality":1,"r-spinWin":1,"r-tebakSkor":1,"q-tebakSkor":1,"q-spinWin":1,"share":1,"quiz":1,"questions":1,"timer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result":"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result","cover":"cover","intro~list~profiling~q-imageInation~result":"intro~list~profiling~q-imageInation~result","ic_url~list~page404~profiling~redirect":"ic_url~list~page404~profiling~redirect","list":"list","profiling~q-tebakSkor~questions":"profiling~q-tebakSkor~questions","profiling":"profiling","intro~q-polling~q-survey~r-polling~r-survey":"intro~q-polling~q-survey~r-polling~r-survey","intro~result":"intro~result","intro":"intro","result":"result","form":"form","ic_url":"ic_url","page404":"page404","redirect":"redirect","leaderboard":"leaderboard","leaderboard_page":"leaderboard_page","leaderboard_widget":"leaderboard_widget","login":"login","question":"question","unique":"unique","r-polling":"r-polling","r-survey":"r-survey","r-checklist":"r-checklist","r-imageInation":"r-imageInation","r-majority":"r-majority","r-personality":"r-personality","r-spinWin":"r-spinWin","r-tebakSkor":"r-tebakSkor","r-timer":"r-timer","r-trivia":"r-trivia","q-imageInation":"q-imageInation","q-tebakSkor":"q-tebakSkor","q-spinWin":"q-spinWin","q-polling":"q-polling","q-survey":"q-survey","q-checklist":"q-checklist","q-majority":"q-majority","q-personality":"q-personality","q-pickapict":"q-pickapict","q-trivia":"q-trivia","share":"share","quiz-imageination":"quiz-imageination","quiz":"quiz","questions":"questions","timer":"timer","shuffle":"shuffle"}[chunkId]||chunkId) + "." + {"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result":"1e674502","cover":"0e7a7a5b","intro~list~profiling~q-imageInation~result":"3fd0a4c4","ic_url~list~page404~profiling~redirect":"fae4c610","list":"11db8580","profiling~q-tebakSkor~questions":"d48adcfe","profiling":"0be7b60b","intro~q-polling~q-survey~r-polling~r-survey":"31d6cfe0","intro~result":"00c276a5","intro":"f0222215","result":"31d6cfe0","form":"31d6cfe0","ic_url":"3d4e141c","page404":"68e6a77c","redirect":"68e6a77c","leaderboard":"31d6cfe0","leaderboard_page":"7cff195a","leaderboard_widget":"4d3d35be","login":"41e5bbbc","question":"31d6cfe0","unique":"fa5c74ad","r-polling":"d12c78f9","r-survey":"4fb0642d","r-checklist":"31d6cfe0","r-imageInation":"f0222215","r-majority":"31d6cfe0","r-personality":"783eaaeb","r-spinWin":"783eaaeb","r-tebakSkor":"e026807a","r-timer":"31d6cfe0","r-trivia":"31d6cfe0","q-imageInation":"31d6cfe0","q-tebakSkor":"3de2375c","q-spinWin":"67aafb7d","q-polling":"31d6cfe0","q-survey":"31d6cfe0","q-checklist":"31d6cfe0","q-majority":"31d6cfe0","q-personality":"31d6cfe0","q-pickapict":"31d6cfe0","q-trivia":"31d6cfe0","share":"4c1b6b69","quiz-imageination":"31d6cfe0","quiz":"672ffc5d","questions":"ba60f4a6","timer":"ff0a7aee","shuffle":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"form": [
 				"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result",
 				"intro~list~profiling~q-imageInation~result",
 				"ic_url~list~page404~profiling~redirect",
 				"profiling~q-tebakSkor~questions",
 				"profiling",
 				"question"
 			],
 			"r-polling": [
 				"share"
 			],
 			"r-survey": [
 				"share"
 			],
 			"r-checklist": [
 				"share"
 			],
 			"r-imageInation": [
 				"share"
 			],
 			"r-majority": [
 				"share"
 			],
 			"r-personality": [
 				"share"
 			],
 			"r-spinWin": [
 				"share"
 			],
 			"r-tebakSkor": [
 				"share"
 			],
 			"r-timer": [
 				"share"
 			],
 			"r-trivia": [
 				"share"
 			],
 			"q-imageInation": [
 				"quiz-imageination"
 			],
 			"q-polling": [
 				"quiz"
 			],
 			"q-survey": [
 				"quiz"
 			],
 			"q-checklist": [
 				"quiz"
 			],
 			"q-majority": [
 				"quiz"
 			],
 			"q-personality": [
 				"quiz"
 			],
 			"q-pickapict": [
 				"quiz"
 			],
 			"q-trivia": [
 				"quiz"
 			],
 			"quiz-imageination": [
 				"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result",
 				"profiling~q-tebakSkor~questions",
 				"questions",
 				"timer"
 			],
 			"quiz": [
 				"cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result",
 				"profiling~q-tebakSkor~questions",
 				"questions",
 				"quiz",
 				"timer"
 			],
 			"questions": [
 				"shuffle"
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdns.klimg.com/newshub.id/interactive2/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["cover~intro~list~profiling~q-imageInation~q-spinWin~q-tebakSkor~questions~result","intro~list~profiling~q-imageInation~result","ic_url~list~page404~profiling~redirect","profiling~q-tebakSkor~questions","profiling","question"]]);
 	return startupResult;
